import { render, staticRenderFns } from "./invitacionSesion.vue?vue&type=template&id=ca2566b8&"
import script from "./invitacionSesion.vue?vue&type=script&lang=js&"
export * from "./invitacionSesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports